import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const AuthGuard: CanActivateFn = async (route, state) => {
  let router = inject(Router)
  let authService = inject(AuthService)

  const existingUser = await authService.getCurrectUserSession()

  /* Dashboard Gaurd */

  if(existingUser && state.url.includes('/dashboard')){
    console.log("user, Dashboard");

    return true
  }
  if(!existingUser && state.url.includes('/dashboard')) {
    console.log("No user, Dashboard");

    router.navigate(['/auth/login'])
    return false
  }

  /* Dashboard Gaurd */

  /* Onboard Gaurd */

  if(existingUser && state.url.includes('/onboard')){
    console.log("user, Onboard");

    return true
  }
  if(!existingUser && state.url.includes('/onboard')) {
    console.log("No user, Onboard");

    router.navigate(['/auth/login'])
    return false
  }
  /* Onboard Gaurd */

  /* Choose Company Gaurd */
  if(existingUser && state.url.includes('/choose_company')) {
    console.log("user, Choose Company");

    return true
  }
  
  if(!existingUser && state.url.includes('/choose_company')) {
    console.log("No user, Choose Company");

    router.navigate(['/auth/login'])
    return false
  }
  /* Choose Company Gaurd */

  /* Auth Gaurd */

  if(existingUser && state.url.includes('/auth')) {
    console.log("user, Auth");

    router.navigate(['/dashboard/home'])
    return false
  }
  if(!existingUser && state.url.includes('/auth')) {
    console.log("No user, Auth");
    
    return true
  }

  /* Auth Gaurd */

  /* Reset Password Gaurd */

  if(existingUser && state.url.includes('/reset_password')) {
    console.log("user, Reset Password");
    return true
  }
  if(!existingUser && state.url.includes('/reset_password')) {
    console.log("No user, Reset Password");
    router.navigate(['/auth/login'])
    
    return true
  }
  
  /* Reset Password Gaurd */

  return false
};
